import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import './plugins/axios'
import vuetify from './plugins/vuetify';
import store from './store'
import App from './App.vue'

import VueRouter from 'vue-router'
import MainWindow from './components/MainWindow.vue'
import Login from './components/Login.vue'
import PasswordRecovery from './components/PasswordRecovery.vue'
import PasswordReset from './components/PasswordReset.vue'
import STBConfigList from './components/STBConfigList.vue'
import UserList from './components/UserList.vue'
import GroupList from './components/GroupList.vue'
import TokenList from './components/TokenList.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: __dirname,
  routes: [
    { path: '/login', component: Login },
    { path: '/password-recovery', component: PasswordRecovery },
    { path: '/password-reset/:prefillEmail', props: true, component: PasswordReset },
    { path: '/password-reset/:prefillEmail/:prefillToken', props: true, component: PasswordReset },
    { path: '/', redirect: '/app/configs/list/user' },
    {
      path: '/app', component: MainWindow, meta: {
        requiresAuth: true
      }, children: [
        { path: 'configs/:layout/:listType', props: true, component: STBConfigList },
        { path: 'configs/:layout/:listType/:tags', props: true, component: STBConfigList },
        { path: 'configs/:layout/:listType/:tags/:id', props: true, component: STBConfigList },
        { path: 'users/:layout', props: true, component: UserList },
        { path: 'users/:layout/:id', props: true, component: UserList },
        { path: 'groups/:layout', props: true, component: GroupList },
        { path: 'groups/:layout/:id', props: true, component: GroupList },
        { path: 'tokens/:layout', props: true, component: TokenList },
        { path: 'tokens/:layout/:id', props: true, component: TokenList },
        { path: '*', redirect: 'configs/list/user' },
      ]
    },
    { path: '*', redirect: '/' },
  ]
})

router.beforeEach((to, _from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

Vue.config.productionTip = false

window.app = new Vue({
  el: '#app',
  vuetify,
  store,
  router,
  render: h => h(App)
})
